import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";


const initialState = {
    isLoading: false,
    itenary: [],
    totalProductItenary: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    iscloading: false,
    cstatus: "",
    cmessage: "",
    baseid: "",
    cdetails: {},
    ismloading: false,
    mstatus: "",
    mmessage: "",
    itmessage: "",
    imessage: "",
    incmessage: "",
    excmessage: "",
    smessage: "",
    pmessage: "",
    apmessage: "",
    rmessage: "",
    itenary: [],
    dstatus: "",
    dmessage: "",

};


const productitenaryListSlice = createSlice({
    name: "productitenaryList",
    initialState,
    reducers:{
        getProductItenaryPending: (state) => {
            state.isLoading = true;
        },
        getProductItenarySuccess: (state, { payload }) => {
            state.isLoading = false;
            state.productitenary = payload;
            state.cdetails = payload;
            state.error = '';
        },
        getProductItenaryFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },

        createItenaryPending: (state, action) => {
            state.iscloading = true;
        },
        createItenarySuccess: (state, { payload }) => {
            state.iscloading = false;
            state.cstatus = "success";
            state.itmessage = payload;
        },
        createItenaryFail: (state, { payload }) => {
            state.iscloading = false;
            state.itmessage = payload;
        },

        getSProductItenaryPending: (state) => {
            state.isLoading = true;
        },
        getSProductItenarySuccess: (state, { payload }) => {
            state.isLoading = false;
            state.itenary = payload;
            // state.user="slice userData";
            state.error = '';
        },
        getSProductItenaryFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        },
        modifyItenaryPending: (state, action) => {
            state.ismloading = true;
            state.mstatus = "";
        },
        modifyItenarySuccess: (state, { payload }) => {
            state.ismloading = false;
            state.mstatus = "success";

            state.mmessage = "Product Itenary Successfully Updated";
        },
        modifyItenaryFail: (state, { payload }) => {
            state.ismloading = false;
            state.mstatus = "fail";
            // console.log('slice '+payload);
            state.mmessage = payload;
        },


        deleteProductItenaryPending: (state, action) => {
            state.isloading = true;
            state.dstatus = "";
        },
        deleteProductItenarySuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "success";
            state.dmessage = "ProductItenary Successfully Deleted";
        },
        deleteProductItenaryFail: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "fail";
            // console.log('slice '+payload);
            state.dmessage = payload;
        },


        //inclusion delete
        deleteInclusionPending: (state, action) => {
            state.isloading = true;
            state.dstatus = "";
        },
        deleteInclusionSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "success";
            state.incmessage = "Inclusion Successfully Deleted";
        },
        deleteInclusionFail: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "fail";
            // console.log('slice '+payload);
            state.incmessage = payload;
        },

        //exclusion delete

        //inclusion delete
        deleteExclusionPending: (state, action) => {
            state.isloading = true;
            state.dstatus = "";
        },
        deleteExclusionSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "success";
            state.excmessage = "Exclusion Successfully Deleted";
        },
        deleteExclusionFail: (state, { payload }) => {
            state.isLoading = false;
            state.dstatus = "fail";
            state.excmessage = payload;
        },

        reset: () => initialState
    },
});

const { reducer, actions } = productitenaryListSlice;

export const { createItenaryFail, createItenaryPending, createItenarySuccess, getSProductItenaryFail,
    getSProductItenaryPending, getSProductItenarySuccess, modifyItenaryFail, modifyItenaryPending,
    modifyItenarySuccess, deleteExclusionFail, deleteExclusionPending, deleteExclusionSuccess, deleteInclusionFail,
    deleteInclusionPending, deleteInclusionSuccess } = actions;

export default reducer;
